import createBoundNumberParser from '../../block-helpers/createBoundNumberParser';

export const DEFAULT_2_COLUMNS = [6] as [number];
export const DEFAULT_3_COLUMNS = [4, 8] as [number, number];

export const COLUMNS_GAP_OPTIONS = { min: 0, max: 80, defaultValue: 16 } as const;
export const COLUMNS_COUNT_OPTIONS = { min: 2, max: 3, defaultValue: 3 } as const;

export const columnsGapParser = createBoundNumberParser(COLUMNS_GAP_OPTIONS);
export const columnsCountParser = createBoundNumberParser(COLUMNS_COUNT_OPTIONS);

export function parseColumnGridDimensions(columnsCount: unknown, value: unknown): [number] | [number, number] {
  if (columnsCount === 2) {
    if (Array.isArray(value) && value.length === 1) {
      const v = value[0];
      if (typeof v === 'number' && v >= 1 && v <= 11) {
        return [v];
      }
    }
    return DEFAULT_2_COLUMNS;
  }

  if (Array.isArray(value) && value.length === 2) {
    const value0 = value[0];
    const value1 = value[1];
    if (typeof value0 === 'number' && typeof value1 === 'number') {
      if (value0 >= 1 && value0 <= 11 && value1 >= 1 && value1 <= 11 && value0 !== value1) {
        return [value0, value1];
      }
    }
  }
  return DEFAULT_3_COLUMNS;
}
